import React, { useState } from 'react';
import Header from './Header';
import '../App.css'

const App = () => {
  const [selectedYear, setSelectedYear] = useState('2026');

  return (
    <div>
      <Header selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
    </div>
  );
};

export default App;
